import React from "react";

/**
 * Minimized Generation Progress Modal
 * Shows in bottom-right corner when there are pending image generation jobs
 * Displays real-time progress as jobs complete
 */
export default function MinimizedGenerationProgress({
  isVisible = false,
  pendingJobsCount = 0,
  bulkTotal = 0,
  onMaximize = () => {},
}) {
  if (!isVisible || pendingJobsCount === 0) return null;

  const progressPercent = bulkTotal > 0 
    ? ((bulkTotal - pendingJobsCount) / bulkTotal) * 100 
    : 0;

  return (
    <div className="fixed bottom-6 right-6 w-96 bg-white rounded-lg shadow-2xl border border-gray-200 flex flex-col z-50 overflow-hidden">
      {/* Header */}
      <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-gradient-to-r from-indigo-50 to-blue-50 flex-shrink-0">
        <h3 className="text-sm font-semibold text-gray-900 truncate">
          Generating World Images
        </h3>
        <button
          onClick={onMaximize}
          className="text-gray-500 hover:text-gray-700 font-bold text-lg"
          aria-label="Maximize modal"
          title="Maximize"
        >
          ⛶
        </button>
      </div>

      {/* Progress Section */}
      <div className="px-4 py-2 flex flex-col justify-center flex-shrink-0">
        <div className="bg-gray-200 rounded-full h-1.5 w-full">
          <div
            className="bg-indigo-600 h-1.5 rounded-full transition-all duration-500"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
        <p className="text-xs font-medium text-gray-700 mt-1.5 text-center">
          {pendingJobsCount > 0
            ? `Generating ${pendingJobsCount} image(s)`
            : "Completing..."}
        </p>
      </div>
    </div>
  );
}
